// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `Hint` component is used for auxiliary text like advice, suggestion or other useful practical information.
 * @since 0.0.35
 */
const Hint = _ref => {
  let {
    baseClassName = `${CLS_PREFIX}hint`,
    className,
    children,
    component: Tag = 'span',
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(Tag, {
    className: classNames(baseClassName, className),
    ...props,
    children: children
  });
};
export default Hint;